import React from 'react';

import withPhotoAlbumCapabilities from 'dpl/decorators/withPhotoAlbumCapabilities';
import { PHOTO_ALBUM_TYPES } from 'dpl/shared/constants/breeder_app';
import ExplorePhotoAlbum from 'dpl/breed_explorer/components/PhotoAlbum';

function ExplorePagePhotoAlbumContainer(props) {
  return <ExplorePhotoAlbum {...props} />;
}

export default withPhotoAlbumCapabilities(PHOTO_ALBUM_TYPES.BREEDER)(
  ExplorePagePhotoAlbumContainer
);
